'use client'

import { useAtomValue } from 'jotai'
import { useSyncExternalStore } from 'react'
import { isActiveAtom } from '@/src/stores/route-machine/atoms'
import { cn } from '@/src/utils/styles'
import { useModalMode } from '../modal-mode-context'
import { TradeModuleWrapper } from '../trade-module-wrapper'

const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  // Setting a custom message may not work on all browsers.
  // The default message will be shown.
  e.preventDefault() // Standard practice to trigger the alert
  e.returnValue = '' // Setting this is necessary for some browsers
}

export default function SwapSection({ className }: { className?: string }) {
  const modal = useModalMode()
  const isTradeActive = useAtomValue(isActiveAtom)

  useSyncExternalStore(
    () => {
      if (isTradeActive) {
        window.addEventListener('beforeunload', handleBeforeUnload)
      } else {
        window.removeEventListener('beforeunload', handleBeforeUnload)
      }
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload)
      }
    },
    () => {},
    () => {},
  )

  return (
    <TradeModuleWrapper
      generatingHotkeyClassName={cn({ 'bg-background': modal })}
      tradeOverviewClassName={cn({ 'rounded-none': modal })}
      swapFormClassName={cn(
        'bg-background',
        {
          'border border-border1': !modal,
          '!static': modal,
        },
        className,
      )}
    />
  )
}
